var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames, renderIcon } from '../..';
export var IconBadge = function (_a) {
    var badgeText = _a.badgeText, icon = _a.icon, className = _a.className, iconColor = _a.iconColor, badgeColor = _a.badgeColor, badgeTextColor = _a.badgeTextColor, onClick = _a.onClick;
    return (_jsxs("span", __assign({ className: classNames(className, 'relative inline-block'), onClick: onClick }, { children: [renderIcon(icon, "w-6 h-6 text-".concat(iconColor)), badgeText && (_jsx("span", __assign({ className: "absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-".concat(badgeTextColor, " transform translate-x-1/2 -translate-y-1/2 bg-").concat(badgeColor, " rounded-full") }, { children: badgeText })))] })));
};
//# sourceMappingURL=icon-badge.js.map